import { getIdToken, signOut } from '../auth/google-auth';

/**
 * Wrapper around fetch that adds Authorization: Bearer header from GSI token.
 * On 401: retries without Bearer (cookie-only) before signing out, so that users
 * stay logged in when the GSI token expires but the 7-day va_session cookie is still valid.
 */
export async function authFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const token = await getIdToken();
  const headers = new Headers(init?.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  const res = await fetch(input, { ...init, headers });
  if (res.status === 401 && token) {
    // Bearer was rejected — try cookie-only before signing out.
    // This handles GSI token expiry, transient Google verification failures, and clock skew.
    try {
      const cookieHeaders = new Headers(init?.headers);
      const cookieRes = await fetch(input, { ...init, headers: cookieHeaders });
      if (cookieRes.status !== 401) return cookieRes;
    } catch { /* ignore */ }
    // Cookie also failed — session is truly gone, sign out
    await signOut();
    if (!window.location.pathname.startsWith('/auth')) {
      window.location.href = '/auth';
    }
  }
  return res;
}
